<template>
  <div
    class="modal fade"
    id="freeOfferFilterChecksDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="freeOfferFilterChecksForm">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
            <h4 class="modal-title">
              <b>{{ lang.SFO200 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <h4 class="filterTitle">{{ lang.SFO203 }}</h4>
              <div class="form-group col-md-12 cb-form-group">
                <div class="pull-left cb-location-free">
                  <select
                    v-model="formModel.LocationFilterValue"
                    class="form-control"
                  >
                    <option :value="locationFilterTypes.LocationAny">
                      {{ lang.SF0226 }}
                    </option>
                    <option :value="locationFilterTypes.LocationFree">
                      {{ lang.SF0227 }}
                    </option>
                    <option :value="locationFilterTypes.LocationNotFree">
                      {{ lang.SF0228 }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group col-md-12 cb-form-group">
                <div class="checkbox pull-left cb-location-free">
                  <label>
                    <input
                      type="checkbox"
                      id="useMyLocation"
                      v-model="useMyLocation"
                      :disabled="
                        formModel.LocationFilterValue ===
                        locationFilterTypes.LocationFree
                      "
                    />
                    <span class="checkbox-material">
                      <span class="check"></span>
                    </span>
                    <span class="text text-black">
                      {{ lang.SFO221 }}
                      <i
                        class="material-icons md-cb-info"
                        id="useMyLocationInfo"
                        v-if="!globals.isMobileBrowser"
                        >info_outline</i
                      >
                    </span>
                  </label>
                </div>
                <b-tooltip
                  ref="tooltip"
                  target="useMyLocationInfo"
                  v-if="!globals.isMobileBrowser"
                  :delay="globals.tooltipDelay"
                  >{{ lang.SFO225 }}</b-tooltip
                >
              </div>
              <div class="col-md-8" v-if="useMyLocation">
                <div
                  id="geocodedLocationString"
                  class="text-red"
                  :class="{ 'text-green': locationString !== lang.SFO224 }"
                >
                  {{ locationString }}
                </div>
              </div>
              <div class="form-group col-md-8" v-else>
                <label
                  for="inputFreeOffersLocation"
                  class="col-md-2 control-label"
                  >{{ lang.SFO206 }}</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="inputFreeOffersLocation"
                    @keypress.enter.prevent
                    @focus="$event.target.select()"
                    @input="resetCurrentLocation()"
                    :disabled="
                      formModel.LocationFilterValue ===
                        locationFilterTypes.LocationFree || useMyLocation
                    "
                  />
                </div>
              </div>
              <div class="form-group col-md-4">
                <label
                  for="inputFreeOffersRadius"
                  class="col-md-6 control-label"
                  >{{ lang.SFO207 }}</label
                >
                <div class="col-md-6">
                  <input
                    id="inputFreeOffersRadius"
                    type="number"
                    class="form-control"
                    v-model.number="distanceInKm"
                    :disabled="
                      formModel.LocationFilterValue ===
                      locationFilterTypes.LocationFree
                    "
                  />
                </div>
              </div>
              <div
                v-show="
                  useFilters &&
                  !(
                    formModel.LocationFilterValue ===
                    locationFilterTypes.LocationFree
                  ) &&
                  !useMyLocation &&
                  !formModel.CurrentLocation.Latitude &&
                  !formModel.CurrentLocation.Longitude
                "
                class="
                  col-md-12
                  help-block
                  error
                  text-danger
                  notification-message
                "
              >
                {{ lang.SFO219 }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="checkbox cb-filter-active">
              <label>
                <input type="checkbox" v-model="useFilters" />
                <span class="checkbox-material">
                  <span class="check"></span>
                </span>
                <span class="text text-black">{{ lang.SFO212 }}</span>
              </label>
            </div>
            <button
              type="button"
              class="btn btn-raised btn-default"
              :class="{ 'pull-left': !globals.isSmallScreen() }"
              @click="resetFilter()"
            >
              {{ lang.SFO214 }}
            </button>
            <button
              type="button"
              class="btn btn-raised btn-default"
              :class="{ 'pull-right': !globals.isSmallScreen() }"
              @click="doFilterChecks()"
            >
              {{ lang.SFO202 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Live from "../../services/Live";

export default {
  name: "FreeOfferFilterChecksDialog",
  props: {
    showDialog: { type: Boolean, default: false },
  },
  data() {
    return {
      useFilters: false,
      useMyLocation: false,
      locationString: "",
      geocoder: null,
      formModel: {
        CurrentLocation: {
          Latitude: 0,
          Longitude: 0,
        },
        Radius: 20000,
        LocationFilterValue: "LocationAny",
      },
      locationFilterTypes: {
        LocationAny: "LocationAny",
        LocationFree: "LocationFree",
        LocationNotFree: "LocationNotFree",
      },
      lang: {
        SFO200: "Filter",
        SFO201: "Location free",
        SFO202: "OK",
        SFO203: "Maximum distance from",
        // SFO204: "Payment",
        // SFO205: "Period",
        SFO206: "Location",
        SFO207: "Distance in km",
        SFO208: "Country",
        SFO209: "Please select...",
        SFO210: "From",
        SFO211: "To",
        SFO212: "Use Filters",
        SFO213: "The end date must not be before the start date",
        SFO214: "Clear inputs",
        SFO215: "Unknown GPS Error",
        SFO216: "GPS request denied by user",
        SFO217: "GPS information is unavailable",
        SFO218: "GPS request timeout",
        SFO219: "Please select any location from the search results!",
        SFO220: "The maximum amount must not be less than the minimum amount",
        SFO221: "Use my current location",
        SFO222: "Location detected",
        SFO223: "Not supported by your browser",
        SFO224: "No address data available",
        SFO225:
          "For devices without GPS (especially PCs/notebooks) the recorded location can deviate significantly",
        SF0226: "All checks",
        SF0227: "Only location free checks",
        SF0228: "Only not location free checks",
      },
    };
  },
  computed: {
    distanceInKm: {
      get() {
        return this.formModel.Radius / 1000;
      },
      set(value) {
        if (value < 0) value = 0;
        else if (value > 1000) value = 1000;
        this.formModel.Radius = value * 1000;
      },
    },
  },
  watch: {
    showDialog(newVal) {
      newVal
        ? this.openFreeOfferFilterChecksDialog()
        : this.closeFreeOfferFilterChecksDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    useMyLocation(newVal) {
      newVal ? this.getCurrentPosition() : this.initPlacesAutocomplete();
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }

    $("#freeOfferFilterChecksDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    if (!window.google) {
      this.globals.$once("googleInitDone", () => {
        this.initPlacesAutocomplete();
        this.initGeocoder();
      });
    } else {
      this.initPlacesAutocomplete();
      this.initGeocoder();
    }
  },
  methods: {
    openFreeOfferFilterChecksDialog() {
      $("#freeOfferFilterChecksDialog").modal("show");
      this.initFreeOfferFilterChecksDialog();
    },
    closeFreeOfferFilterChecksDialog() {
      $("#freeOfferFilterChecksDialog").modal("hide");
    },
    initPlacesAutocomplete() {
      this.$nextTick(() => {
        let input = document.getElementById("inputFreeOffersLocation");
        if (!input) return;
        if (this.locationString && this.locationString !== this.lang.SFO224)
          input.value = this.locationString;
        let autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.setFields(["geometry"]);
        autocomplete.addListener("place_changed", () => {
          let place = autocomplete.getPlace();
          if (!place.geometry) {
            this.resetCurrentLocation();
            return;
          }
          this.formModel.CurrentLocation = {
            Latitude: place.geometry.location.lat(),
            Longitude: place.geometry.location.lng(),
          };
        });
      });
    },
    initGeocoder() {
      this.geocoder = new google.maps.Geocoder();

      // Test whether the geocoder is working. If not, try to clear all cached data and reload.
      // #1828
      this.geocoder.geocode({ address: "Dubiln" }, (results, status) => {
        if (status != google.maps.GeocoderStatus.OK) {
          Live.clearSiteDataAll();
          window.location.reload();
        }
      });
    },
    initFreeOfferFilterChecksDialog() {
      if (!this.$firstOpeningDone) {
        this.useFilters = true;
        this.$firstOpeningDone = true;
      }
    },
    resetFilter() {
      this.formModel = {
        CurrentLocation: {
          Latitude: 0,
          Longitude: 0,
        },
        Radius: 20000,
        LocationFilterValue: this.locationFilterTypes.LocationAny,
      };
      this.useMyLocation = false;
      this.locationString = "";
      let input = document.getElementById("inputFreeOffersLocation");
      if (input) input.value = "";
    },
    resetCurrentLocation() {
      this.formModel.CurrentLocation.Latitude = 0;
      this.formModel.CurrentLocation.Longitude = 0;
    },
    removeEmptyProperties(filterOptions) {
      if (
        filterOptions.LocationFree ||
        (!filterOptions.CurrentLocation.Latitude &&
          !filterOptions.CurrentLocation.Longitude)
      ) {
        delete filterOptions.CurrentLocation;
        delete filterOptions.Radius;
      }
      delete filterOptions.LocationFilterValue;
    },
    doFilterChecks() {
      let filterOptions = _.cloneDeep(this.formModel);
      delete filterOptions.LocationFree;
      if (
        filterOptions.LocationFilterValue ===
        this.locationFilterTypes.LocationFree
      ) {
        filterOptions.LocationFree = true;
      }
      if (
        filterOptions.LocationFilterValue ===
        this.locationFilterTypes.LocationNotFree
      ) {
        filterOptions.LocationFree = false;
      }

      this.removeEmptyProperties(filterOptions);
      if (this.useFilters && !_.isEmpty(filterOptions))
        this.$emit("filterChecks", filterOptions);
      else this.$emit("filterChecks");
      this.closeFreeOfferFilterChecksDialog();
    },
    getCurrentPosition() {
      this.locationString = "";

      if (navigator.geolocation) {
        let success = (pos) => {
          this.formModel.CurrentLocation.Longitude = pos.coords.longitude;
          this.formModel.CurrentLocation.Latitude = pos.coords.latitude;

          let latlng = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          this.geocoder.geocode({ location: latlng }, (results, status) => {
            if (status !== "OK") {
              this.globals.showErrorSnackbar(
                `Geocoding failed with status ${status}`
              );
              console.error(`Geocoding failed with status ${status}`);
              this.locationString = this.lang.SFO224;
              return;
            }

            let locality = _.find(results, (r) => {
              return _.indexOf(r.types, "locality") > -1;
            });
            if (locality && locality.formatted_address) {
              this.locationString = locality.formatted_address;
              this.globals.showSuccessSnackbar(this.lang.SFO222);
            } else this.locationString = this.lang.SFO224;
          });
        };
        let error = (error) => {
          let errMsg = this.lang.SFO215;
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errMsg = this.lang.SFO216;
              break;
            case error.POSITION_UNAVAILABLE:
              errMsg = this.lang.SFO217;
              break;
            case error.TIMEOUT:
              errMsg = this.lang.SFO218;
              break;
          }
          this.globals.showErrorSnackbar(errMsg);
          this.useMyLocation = false;
        };
        navigator.geolocation.getCurrentPosition(success, error);
      } else this.globals.showErrorSnackbar(this.lang.SFO223);
    },
  },
};
</script>

<style scoped>
.filterTitle {
  text-align: center;
  background: #eee;
  font-weight: bold;
  padding: 5px;
}

.form-control {
  font-size: 1.5em !important;
}

.material-icons.md-24 {
  font-size: 20px;
}

.material-icons.md-cb-info {
  font-size: 24px;
  position: relative;
  top: 5px;
}

.modal-footer .btn + .btn {
  margin: 5px;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}

.modal-footer > .btn {
  margin: 5px !important;
  left: 0 !important;
}

.modal-body .cb-form-group {
  overflow: hidden;
}

.cb-location-free {
  margin-left: 20px;
}

.cb-filter-active {
  display: inline-block;
}
.modal-footer {
  text-align: center;
}

#geocodedLocationString {
  padding: 10px;
}

@supports not (-moz-appearance: none) {
  @media (min-width: 1001px) {
    .checkbox .text {
      position: relative;
      top: 2px;
      left: 2px;
    }
  }
}

@media (max-width: 1000px) {
  .filterTitle {
    font-size: 1.2em;
  }

  .material-icons.md-24 {
    font-size: 40px;
  }

  .notification-message {
    font-size: 36px;
  }

  @media screen and (max-aspect-ratio: 13/9) {
    #freeOfferFilterChecksDialog > .modal-dialog {
      width: 100vw;
      margin: 0;
    }

    #freeOfferFilterChecksDialog > .modal-dialog .modal-footer {
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      background: lightgray;
      z-index: 1000;
    }

    .cb-filter-active {
      display: block;
      margin: 1em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// FreeOfferFilterChecksDialog.vue?021b340f